import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  keywords?: string;
  author?: string;
  type?: 'website' | 'article' | 'profile';
}
export function SEO({
  title = 'Katia Engalycheva | Marketing & Product Strategist',
  description = 'Marketing & Product Strategist working at the intersection of growth, marketing, and monetization. Translating deep user empathy and complex market needs into scalable products.',
  image = 'https://cdn.magicpatterns.com/uploads/1sRmN98EtHVewhdL6qipi1/Снимок_экрана_2026-01-04_в_20.51.11.png',
  url = 'https://theideasboutique.com',
  keywords = 'product strategist, marketing strategist, product management, UX design, go-to-market strategy, brand positioning, product development, growth strategy',
  author = 'Katia Engalycheva',
  type = 'website'
}: SEOProps) {
  // Load Google Analytics on component mount
  useEffect(() => {
    // Create and append gtag script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-KYMVS5J98X';
    document.head.appendChild(gtagScript);
    // Create and append gtag config script
    const gtagConfigScript = document.createElement('script');
    gtagConfigScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-KYMVS5J98X');
    `;
    document.head.appendChild(gtagConfigScript);
    // Cleanup function
    return () => {
      // Note: We don't remove scripts on unmount to preserve analytics tracking
    };
  }, []);
  // Schema.org Person/Professional structured data
  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Katia Engalycheva',
    jobTitle: 'Marketing & Product Strategist',
    description: 'Marketing & Product Strategist working at the intersection of growth, marketing, and monetization.',
    url: 'https://theideasboutique.com',
    image: 'https://cdn.magicpatterns.com/uploads/1sRmN98EtHVewhdL6qipi1/Снимок_экрана_2026-01-04_в_20.51.11.png',
    sameAs: ['https://www.linkedin.com/in/katiaengalycheva/'],
    knowsAbout: ['Product Strategy', 'Marketing Strategy', 'Product Management', 'UX Design', 'Go-to-Market Strategy', 'Brand Positioning', 'Growth Strategy', 'Product Development'],
    alumniOf: {
      '@type': 'Organization',
      name: 'International Olympic Committee'
    }
  };
  return <>
      <Helmet data-id="element-216">
        {/* Primary Meta Tags */}
        <title data-id="element-217">{title}</title>
        <meta name="title" content={title} data-id="element-218" />
        <meta name="description" content={description} data-id="element-219" />
        <meta name="author" content={author} data-id="element-220" />
        <meta name="keywords" content={keywords} data-id="element-221" />
        <meta name="robots" content="index, follow" data-id="element-222" />

        {/* Canonical URL */}
        <link rel="canonical" href={url} data-id="element-223" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content={type} data-id="element-224" />
        <meta property="og:url" content={url} data-id="element-225" />
        <meta property="og:title" content={title} data-id="element-226" />
        <meta property="og:description" content={description} data-id="element-227" />
        <meta property="og:image" content={image} data-id="element-228" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" data-id="element-229" />
        <meta property="twitter:url" content={url} data-id="element-230" />
        <meta property="twitter:title" content={title} data-id="element-231" />
        <meta property="twitter:description" content={description} data-id="element-232" />
        <meta property="twitter:image" content={image} data-id="element-233" />
      </Helmet>

      {/* Schema.org Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(personSchema)
    }} data-id="element-234" />
    </>;
}